import { render, staticRenderFns } from "./DashboardStatusRoom.vue?vue&type=template&id=63054f8e&"
import script from "./DashboardStatusRoom.vue?vue&type=script&lang=js&"
export * from "./DashboardStatusRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports